import type { TaskType } from '@api';
import { Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Anchor } from '../../../Anchor';
import { LinkableEntityList } from '../../../LinkableEntity';
import { DetailSection } from '../DetailSection';

const TRANS_COLUMNS = 'TABLE.COLUMNS';

type TaskDetailsContentPropsType = {
  task: TaskType;
};

export const TaskDetailsContent: React.FC<TaskDetailsContentPropsType> = ({
  task,
}) => {
  const { t } = useTranslation(['tasks', 'common']);
  const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

  return (
    <Stack>
      <DetailSection label={t(`${TRANS_COLUMNS}.DESCRIPTION`)}>
        <Text size="sm">{task.description || noDataPlaceholder}</Text>
      </DetailSection>

      <DetailSection label={t(`${TRANS_COLUMNS}.CONTEXT`)}>
        {task.context ? (
          <Anchor to={task.context}>{task.context}</Anchor>
        ) : (
          <Text size="sm">{noDataPlaceholder}</Text>
        )}
      </DetailSection>

      <DetailSection label={t(`${TRANS_COLUMNS}.AUDIENCE`)}>
        <Text size="sm">
          {task.audience.length > 0 ? (
            <LinkableEntityList entities={task.audience} />
          ) : (
            noDataPlaceholder
          )}
        </Text>
      </DetailSection>
    </Stack>
  );
};
